import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Typography, makeStyles } from "@material-ui/core";
import Menu from "../../organisms/Menu/menu";
import NavBar from "../../organisms/NavBar/nav-bar";

export default function LegalDocument({ children, effectiveDate, title }) {
  const classes = useStyle();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={classes.root}>
      <section className={classes.section}>
        <Menu className={classes.menu} canBeVisible noWait />
        <Box className={classes.wrapperPage}>
          <NavBar />
          <article className={classes.containerContent}>
            <Typography variant="h1">{title}</Typography>
            {effectiveDate && (
              <p className={classes.effectiveDate}>
                Effective date: {effectiveDate}
              </p>
            )}
            <div className={classes.wrapperText}>{children}</div>
          </article>
        </Box>
      </section>
    </div>
  );
}

LegalDocument.propTypes = {
  children: PropTypes.node.isRequired,
  effectiveDate: PropTypes.string,
  title: PropTypes.string.isRequired,
};

LegalDocument.defaultProps = {
  effectiveDate: "",
};

const useStyle = makeStyles(({ breakpoints, palette }) => ({
  root: {
    overflowX: "hidden",
    color: "white",
    background: "#0d1625",
    fontFamily: "Montserrat, sans-serif",
  },
  section: {
    position: "relative",
    width: "100%",
    minHeight: "100vh",
  },
  menu: {
    position: "fixed",
    zIndex: 2,
    width: "10rem",
    minWidth: "10rem",
    height: "100%",
    padding: "6rem 0",
    background: "transparent",
    transform: "translate(0)",
    [breakpoints.down("xs")]: {
      display: "none",
    },
  },
  wrapperPage: {
    width: "100%",
    minHeight: "100vh",
    padding: "3rem",
    [breakpoints.up("sm")]: {
      paddingLeft: "13rem",
    },
    [breakpoints.down("xs")]: {
      padding: "2rem 1.5rem",
    },
  },
  containerContent: {
    width: "100%",
    maxWidth: "104rem",
    minHeight: "calc(100vh - 17rem)",
    margin: "0 auto",
    "& h1": {
      width: "100%",
      marginTop: "3rem",
      color: "white",
      fontFamily: "Akira",
      fontSize: "4.8rem",
      fontWeight: 600,
      lineHeight: 1.2,
      textAlign: "center",
      textTransform: "uppercase",
      textShadow: "0 3px 9px rgba(0, 0, 0, 0.58)",
      whiteSpace: "pre-wrap",
      [breakpoints.down("sm")]: {
        fontSize: "3rem",
      },
      [breakpoints.down("xs")]: {
        fontSize: "2.4rem",
      },
    },
  },
  effectiveDate: {
    margin: "1.5rem 0 0",
    color: "rgba(255, 255, 255, 0.72)",
    fontSize: "1.2rem",
    textAlign: "center",
  },
  wrapperText: {
    marginTop: "3rem",
    fontSize: "1.35rem",
    lineHeight: 1.65,
    "& h2": {
      margin: "3rem 0 1rem",
      color: "white",
      fontFamily: "Akira",
      fontSize: "1.9rem",
      lineHeight: 1.35,
    },
    "& h3": {
      margin: "2rem 0 0.8rem",
      fontSize: "1.5rem",
      lineHeight: 1.4,
    },
    "& p, & li": {
      color: "rgba(255, 255, 255, 0.88)",
    },
    "& ul": {
      paddingLeft: "2rem",
    },
    "& li": {
      marginBottom: "0.7rem",
    },
    "& a": {
      color: palette.primary.light,
    },
    "& table": {
      width: "100%",
      margin: "1.5rem 0",
      borderCollapse: "collapse",
    },
    "& th, & td": {
      padding: "1rem",
      border: "1px solid rgba(255, 255, 255, 0.22)",
      color: "rgba(255, 255, 255, 0.88)",
      textAlign: "left",
      verticalAlign: "top",
    },
    "& th": {
      color: "white",
      background: "rgba(255, 255, 255, 0.08)",
    },
    [breakpoints.down("xs")]: {
      overflowX: "auto",
      fontSize: "1.2rem",
      "& h2": {
        fontSize: "1.6rem",
      },
      "& th, & td": {
        minWidth: "13rem",
      },
    },
  },
}));
